export const availableModules = [
    'home',
    'profile',
    'users',
    'groups',
    'companies',
    'tags',
    'types',
    'roles',
    'reports',
    'tickets',
    'channels',
    'settings',
    'contacts',
    'contacts_groups',
    'bots',
    'notifications',
    'customFields',
    'templates',
    'campaigns',
    'aiSettings',
    'tools',
    'records',
    'chatbots',
    'ia-tester',
    'users-tracking',
    'users-options',
    'bg-task',
] as const;

export type AppModule = (typeof availableModules)[number];

// export enum AppModules {
//     DASHBOARD = 'DASHBOARD',
//     USERS = 'USERS',
//     GROUPS = 'GROUPS',
//     COMPANIES = 'COMPANIES',
//     TAGS = 'TAGS',
//     TYPES = 'TYPES',
//     PERMISSIONS = 'PERMISSIONS',
//     ROLS = 'ROLS',
//     TICKETS = 'TICKETS',
//
//
// }

// export enum ModuleAction {
//     CREATE = 'CREATE',
//     UPDATE = 'UPDATE',
//     DELETE = 'DELETE',
//     TO_LIST = 'TO_LIST',
//     DETAILS = 'DETAILS',
//     CREATE_AND_UPDATE = 'CREATE_AND_UPDATE',
//     DISABLE = 'DISABLE',
//     ENABLE = 'ENABLE',
//
//     //user
//     USERS_CHANGE_PASSWORD = 'USERS_CHANGE_PASSWORD',
//
//
// }

//Ticket Actions
export const availableTicketsActions = [
    'changeStatus',
    'changeStatusAdmin',
    'detailsAdmin',
    'assignMe',
    'transferTicket',
    'more_actions',
] as const;
//Chatbot Companies Actions
/*export const availableChatbotsActions = [
    'chatbotDetails',
    'chatbotAdd',
    'chatbotEdit',
    'chatbotDelete',
    'chatbotChangeStatus',
]*/
//Module Actions
export const availableModuleActions = [
    ...availableTicketsActions,
    'create',
    'list',
    'update',
    'delete',
    'details',
    'disable',
    'enable',
    'export',
    'import',
    'unify',
    'block',
    'export_historic',
    'change_state',
] as const;

export type ModuleAction = (typeof availableModuleActions)[number];

export interface IModuleInfo {
    label: string;
    path: string;
    module: AppModule;
    availableActions: ModuleAction[];
}
